import { render } from "./FaqPage.vue?vue&type=template&id=2a8da23f&scoped=true&ts=true"
import script from "./FaqPage.vue?vue&type=script&lang=ts"
export * from "./FaqPage.vue?vue&type=script&lang=ts"

import "./FaqPage.vue?vue&type=style&index=0&id=2a8da23f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8da23f"]])

export default __exports__